(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["best-sellers"] && !Shopify.designMode) return;
  try {
    
  function initBestSellers() {
    // 1. Tab Switching Controller
    const tabButtons = document.querySelectorAll('.best-sellers__tab-btn');
    const tabPanels = document.querySelectorAll('.best-sellers__tab-panel');

    tabButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        const targetId = btn.getAttribute('data-tab-target');

        // Deactivate active buttons and panels
        tabButtons.forEach(b => b.classList.remove('active'));
        tabPanels.forEach(panel => {
          panel.classList.remove('active', 'show-active');
        });

        // Activate selected
        btn.classList.add('active');
        const targetPanel = document.getElementById(targetId);
        if (targetPanel) {
          targetPanel.classList.add('active');
          // Trigger CSS transition
          setTimeout(() => {
            targetPanel.classList.add('show-active');
          }, 30);
        }
      });
    });

    // 2. Wishlist Heart Toggle handled globally in theme-ajax-sync.liquid

    // 3. Card Carousel Dots & Auto-Rotate on Hover
    const cards = document.querySelectorAll('.best-sellers__card');

    cards.forEach(card => {
      const slides = card.querySelectorAll('.best-sellers__img');
      const dots = card.querySelectorAll('.dot');
      let currentIdx = 0;
      let intervalId = null;

      function showSlide(index) {
        if (slides.length <= 1) return;
        
        // Wrap index around
        const idx = (index + slides.length) % slides.length;
        currentIdx = idx;

        slides.forEach((slide, i) => {
          if (i === idx) {
            slide.classList.add('active');
          } else {
            slide.classList.remove('active');
          }
        });

        dots.forEach((dot, i) => {
          if (i === idx) {
            dot.classList.add('dot--active');
          } else {
            dot.classList.remove('dot--active');
          }
        });
      }

      // Add dot click events
      dots.forEach(dot => {
        dot.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const slideTo = parseInt(dot.getAttribute('data-slide-to') || dot.getAttribute('data-index') || 0);
          showSlide(slideTo);
          stopAutoplay();
        });
      });

      // Hover autoplay logic
      function startAutoplay() {
        if (slides.length <= 1) return;
        stopAutoplay();
        intervalId = setInterval(() => {
          showSlide(currentIdx + 1);
        }, 1800); // Cycle every 1.8 seconds on hover
      }

      function stopAutoplay() {
        if (intervalId) {
          clearInterval(intervalId);
          intervalId = null;
        }
      }

      card.addEventListener('mouseenter', startAutoplay);
      card.addEventListener('mouseleave', () => {
        stopAutoplay();
        showSlide(0); // Reset to first slide on mouse leave
      });
    });
  }

  // Support both page loads and theme customizer reloading
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBestSellers);
  } else {
    initBestSellers();
  }
  
  // Customizer event support
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.best-sellers')) {
      initBestSellers();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category-showcase"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initGoldShowcaseSliders() {
    const sliderContainers = document.querySelectorAll('.category-showcase__slider-container');
    
    sliderContainers.forEach(container => {
      if (container.dataset.sliderInitialized === 'true') return;
      container.dataset.sliderInitialized = 'true';

      const grid = container.querySelector('.category-showcase__grid');
      const prevBtn = container.querySelector('.category-showcase__nav-arrow--left');
      const nextBtn = container.querySelector('.category-showcase__nav-arrow--right');
      const dots = container.querySelectorAll('.category-showcase__progress-segment');
      const currentSlideText = container.querySelector('.category-showcase__current-slide');
      const items = container.querySelectorAll('.category-showcase__item');

      if (!grid) return;

      function updateControls() {
        const scrollLeft = grid.scrollLeft;
        const maxScroll = grid.scrollWidth - grid.clientWidth - 8;

        if (prevBtn) {
          if (scrollLeft > 10) {
            prevBtn.classList.add('is-visible');
          } else {
            prevBtn.classList.remove('is-visible');
          }
        }

        if (nextBtn) {
          if (scrollLeft < maxScroll) {
            nextBtn.classList.add('is-visible');
          } else {
            nextBtn.classList.remove('is-visible');
          }
        }

        if (dots.length > 0 && items.length > 0) {
          let activeIndex = 0;
          let minDistance = Infinity;

          items.forEach((item, index) => {
            const distance = Math.abs(item.offsetLeft - grid.offsetLeft - grid.scrollLeft);
            if (distance < minDistance) {
              minDistance = distance;
              activeIndex = index;
            }
          });

          dots.forEach((dot, index) => {
            if (index === activeIndex) {
              dot.classList.add('is-active');
            } else {
              dot.classList.remove('is-active');
            }
          });

          if (currentSlideText) {
            currentSlideText.textContent = ('0' + (activeIndex + 1)).slice(-2);
          }
        }
      }

      updateControls();

      grid.addEventListener('scroll', updateControls, { passive: true });
      window.addEventListener('resize', updateControls, { passive: true });

      // Directional gesture handling for mobile touch
      let startX = 0;
      let startY = 0;
      let isTouching = false;
      let gestureDirection = null;

      grid.addEventListener('touchstart', (e) => {
        if (e.touches.length !== 1) return;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        isTouching = true;
        gestureDirection = null;
      }, { passive: true });

      grid.addEventListener('touchmove', (e) => {
        if (!isTouching || e.touches.length !== 1) return;
        const currentX = e.touches[0].clientX;
        const currentY = e.touches[0].clientY;
        const deltaX = currentX - startX;
        const deltaY = currentY - startY;

        if (!gestureDirection) {
          const absX = Math.abs(deltaX);
          const absY = Math.abs(deltaY);
          if (absX > 6 || absY > 6) {
            if (absX >= absY) {
              gestureDirection = 'horizontal';
            } else {
              gestureDirection = 'vertical';
            }
          }
        }

        if (gestureDirection === 'vertical') {
          // Do not interfere with default browser vertical page scroll
          return;
        }
      }, { passive: true });

      grid.addEventListener('touchend', () => {
        isTouching = false;
        gestureDirection = null;
      }, { passive: true });

      grid.addEventListener('touchcancel', () => {
        isTouching = false;
        gestureDirection = null;
      }, { passive: true });

      if (prevBtn) {
        prevBtn.addEventListener('click', function(e) {
          e.preventDefault();
          const cardWidth = items[0]?.offsetWidth || 160;
          grid.scrollBy({ left: -(cardWidth + 16), behavior: 'smooth' });
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function(e) {
          e.preventDefault();
          const cardWidth = items[0]?.offsetWidth || 160;
          grid.scrollBy({ left: (cardWidth + 16), behavior: 'smooth' });
        });
      }

      dots.forEach((dot, index) => {
        dot.addEventListener('click', function() {
          if (items[index]) {
            grid.scrollTo({ left: items[index].offsetLeft - grid.offsetLeft, behavior: 'smooth' });
          }
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGoldShowcaseSliders);
  } else {
    initGoldShowcaseSliders();
  }

  document.addEventListener('shopify:section:load', initGoldShowcaseSliders);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const questions = document.querySelectorAll('.faq-question');
    questions.forEach(question => {
      question.addEventListener('click', function() {
        const expanded = this.getAttribute('aria-expanded') === 'true';
        this.setAttribute('aria-expanded', !expanded);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["for-every-you"] && !Shopify.designMode) return;
  try {
    
class ForEveryYouCarousel {
  constructor(element) {
    this.section = element;
    this.section.carousel = this;
    this.track = element.querySelector('.for-every-you__track');
    this.slides = Array.from(element.querySelectorAll('.for-every-you__slide'));
    this.prevBtn = element.querySelector('.for-every-you__nav--prev');
    this.nextBtn = element.querySelector('.for-every-you__nav--next');
    
    if (!this.track || this.slides.length === 0) return;
    
    this.N = this.slides.length;
    this.targetProgress = 0;
    this.currentProgress = 0;
    
    this.isDragging = false;
    this.startX = 0;
    this.startY = 0;
    this.startProgress = 0;
    
    this.init();
  }

  init() {
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.targetProgress -= 1;
      });
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.targetProgress += 1;
      });
    }

    // Drag events
    this.track.addEventListener('mousedown', this.onDragStart.bind(this));
    window.addEventListener('mousemove', this.onDragMove.bind(this));
    window.addEventListener('mouseup', this.onDragEnd.bind(this));
    
    this.track.addEventListener('touchstart', this.onDragStart.bind(this), {passive: true});
    window.addEventListener('touchmove', this.onDragMove.bind(this), {passive: false});
    window.addEventListener('touchend', this.onDragEnd.bind(this));

    this.track.addEventListener('click', (e) => {
      if (this.hasDragged) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);

    this.animate();
  }
  
  onDragStart(e) {
    if (e.type === 'touchstart') {
      this.startX = e.touches[0].clientX;
      this.startY = e.touches[0].clientY;
      this.isScrolling = undefined;
    } else {
      this.startX = e.clientX;
      e.preventDefault(); 
    }
    this.isDragging = true;
    this.hasDragged = false;
    this.startProgress = this.targetProgress;
    this.track.style.cursor = 'grabbing';
  }
  
  onDragMove(e) {
    if (!this.isDragging) return;
    let currentX = e.type === 'touchmove' ? e.touches[0].clientX : e.clientX;
    let currentY = e.type === 'touchmove' ? e.touches[0].clientY : 0;
    
    let deltaX = currentX - this.startX;
    
    if (Math.abs(deltaX) > 5) {
      this.hasDragged = true;
    }
    
    if (e.type === 'touchmove') {
      let deltaY = currentY - this.startY;
      if (typeof this.isScrolling === 'undefined') {
        this.isScrolling = Math.abs(deltaY) > Math.abs(deltaX);
      }
      if (this.isScrolling) {
        this.isDragging = false;
        return; 
      }
      if (e.cancelable) e.preventDefault(); 
    }
    
    let slideWidth = this.slides[0].clientWidth || 300;
    this.targetProgress = this.startProgress - (deltaX / slideWidth) * 1.5;
  }
  
  onDragEnd() {
    if (!this.isDragging) return;
    this.isDragging = false;
    this.track.style.cursor = '';
    this.targetProgress = Math.round(this.targetProgress);
  }

  animate() {
    this.currentProgress += (this.targetProgress - this.currentProgress) * 0.1;
    this.render();
    requestAnimationFrame(this.animate.bind(this));
  }
  
  render() {
    const N = this.N;
    const isMobile = window.innerWidth <= 768;
    const baseOffset = isMobile ? 180 : 260;
    const extraOffset = isMobile ? 130 : 200;
    
    this.slides.forEach((slide, i) => {
      let diff = ((i - this.currentProgress) % N + N) % N;
      if (diff > N / 2) diff -= N;
      
      let sign = Math.sign(diff);
      let absDiff = Math.abs(diff);
      
      let translateX = 0;
      let rotateY = 0;
      let scale = 1;
      let opacity = 1;
      
      if (absDiff <= 1) {
        translateX = sign * absDiff * baseOffset;
        scale = 1.05 - absDiff * 0.2; 
        rotateY = sign * absDiff * -25;
        opacity = 1 - absDiff * 0.2; 
      } else if (absDiff <= 2) {
        let excess = absDiff - 1;
        translateX = sign * (baseOffset + excess * extraOffset);
        scale = 0.85 - excess * 0.15; 
        rotateY = sign * (-25 - excess * 15);
        opacity = 0.8 - excess * 0.4; 
      } else {
        let excess = absDiff - 2;
        translateX = sign * (baseOffset + extraOffset + excess * extraOffset);
        scale = 0.70 - excess * 0.15; 
        rotateY = sign * (-40 - excess * 15);
        opacity = 0.4 - excess * 0.8; 
      }
      
      if (opacity <= 0) {
        slide.style.opacity = 0;
        slide.style.pointerEvents = 'none';
        slide.style.zIndex = -1;
        return;
      }
      
      let zIndex = Math.round(100 - absDiff * 10);
      
      slide.style.transform = `translateX(${translateX}px) scale(${scale}) rotateY(${rotateY}deg)`;
      slide.style.zIndex = zIndex;
      slide.style.opacity = opacity;
      
      if (absDiff < 0.5) {
        slide.classList.add('is-active');
      } else {
        slide.classList.remove('is-active');
      }
      slide.style.pointerEvents = 'auto';
    });
  }
}
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.for-every-you').forEach(section => {
    new ForEveryYouCarousel(section);
  });
});
document.addEventListener('shopify:section:load', (event) => {
  const section = event.target.querySelector('.for-every-you');
  if (section) {
    new ForEveryYouCarousel(section);
  }
});

document.addEventListener('shopify:block:select', (event) => {
  const slide = event.target;
  if (!slide.classList.contains('for-every-you__slide')) return;
  
  const section = slide.closest('.for-every-you');
  if (!section || !section.carousel) return;
  
  const targetIndex = parseInt(slide.getAttribute('data-index'), 10);
  if (!isNaN(targetIndex)) {
    const N = section.carousel.N;
    let currentMod = section.carousel.targetProgress % N;
    if (currentMod < 0) currentMod += N;
    
    let diff = targetIndex - currentMod;
    if (diff > N / 2) diff -= N;
    if (diff < -N / 2) diff += N;
    
    section.carousel.targetProgress += diff;
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gold-collection-showcase"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initGoldShowcaseSliders() {
    const sliderContainers = document.querySelectorAll('.gold-showcase__slider-container');
    
    sliderContainers.forEach(container => {
      if (container.dataset.sliderInitialized === 'true') return;
      container.dataset.sliderInitialized = 'true';

      const grid = container.querySelector('.gold-showcase__grid');
      const prevBtn = container.querySelector('.gold-showcase__nav-arrow--left');
      const nextBtn = container.querySelector('.gold-showcase__nav-arrow--right');
      const dots = container.querySelectorAll('.gold-showcase__progress-segment');
      const currentSlideText = container.querySelector('.gold-showcase__current-slide');
      const items = container.querySelectorAll('.gold-showcase__item');

      if (!grid) return;

      function updateControls() {
        const scrollLeft = grid.scrollLeft;
        const maxScroll = grid.scrollWidth - grid.clientWidth - 8;

        if (prevBtn) {
          if (scrollLeft > 10) {
            prevBtn.classList.add('is-visible');
          } else {
            prevBtn.classList.remove('is-visible');
          }
        }

        if (nextBtn) {
          if (scrollLeft < maxScroll) {
            nextBtn.classList.add('is-visible');
          } else {
            nextBtn.classList.remove('is-visible');
          }
        }

        if (dots.length > 0 && items.length > 0) {
          let activeIndex = 0;
          let minDistance = Infinity;

          items.forEach((item, index) => {
            const distance = Math.abs(item.offsetLeft - grid.offsetLeft - grid.scrollLeft);
            if (distance < minDistance) {
              minDistance = distance;
              activeIndex = index;
            }
          });

          dots.forEach((dot, index) => {
            if (index === activeIndex) {
              dot.classList.add('is-active');
            } else {
              dot.classList.remove('is-active');
            }
          });

          if (currentSlideText) {
            currentSlideText.textContent = ('0' + (activeIndex + 1)).slice(-2);
          }
        }
      }

      updateControls();

      grid.addEventListener('scroll', updateControls, { passive: true });
      window.addEventListener('resize', updateControls, { passive: true });

      // Directional gesture handling for mobile touch
      let startX = 0;
      let startY = 0;
      let isTouching = false;
      let gestureDirection = null;

      grid.addEventListener('touchstart', (e) => {
        if (e.touches.length !== 1) return;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        isTouching = true;
        gestureDirection = null;
      }, { passive: true });

      grid.addEventListener('touchmove', (e) => {
        if (!isTouching || e.touches.length !== 1) return;
        const currentX = e.touches[0].clientX;
        const currentY = e.touches[0].clientY;
        const deltaX = currentX - startX;
        const deltaY = currentY - startY;

        if (!gestureDirection) {
          const absX = Math.abs(deltaX);
          const absY = Math.abs(deltaY);
          if (absX > 6 || absY > 6) {
            if (absX >= absY) {
              gestureDirection = 'horizontal';
            } else {
              gestureDirection = 'vertical';
            }
          }
        }

        if (gestureDirection === 'vertical') {
          // Do not interfere with default browser vertical page scroll
          return;
        }
      }, { passive: true });

      grid.addEventListener('touchend', () => {
        isTouching = false;
        gestureDirection = null;
      }, { passive: true });

      grid.addEventListener('touchcancel', () => {
        isTouching = false;
        gestureDirection = null;
      }, { passive: true });

      if (prevBtn) {
        prevBtn.addEventListener('click', function(e) {
          e.preventDefault();
          const cardWidth = items[0]?.offsetWidth || 160;
          grid.scrollBy({ left: -(cardWidth + 16), behavior: 'smooth' });
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function(e) {
          e.preventDefault();
          const cardWidth = items[0]?.offsetWidth || 160;
          grid.scrollBy({ left: (cardWidth + 16), behavior: 'smooth' });
        });
      }

      dots.forEach((dot, index) => {
        dot.addEventListener('click', function() {
          if (items[index]) {
            grid.scrollTo({ left: items[index].offsetLeft - grid.offsetLeft, behavior: 'smooth' });
          }
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGoldShowcaseSliders);
  } else {
    initGoldShowcaseSliders();
  }

  document.addEventListener('shopify:section:load', initGoldShowcaseSliders);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  function initMobileMenu() {
    const hamburger = document.querySelector('.header__hamburger');
    const drawer = document.getElementById('MobileNavDrawer');
    const closeBtn = document.getElementById('MobileNavClose');
    const overlay = document.getElementById('MobileNavOverlay');
    const body = document.body;

    if (!hamburger || !drawer) return;
    if (hamburger.dataset.menuInitialized === 'true') return;
    hamburger.dataset.menuInitialized = 'true';

    hamburger.addEventListener('click', function() {
      const expanded = hamburger.getAttribute('aria-expanded') === 'true';
      hamburger.setAttribute('aria-expanded', !expanded);
      drawer.classList.add('mobile-menu-drawer--open');
      drawer.setAttribute('aria-hidden', 'false');
      body.classList.add('body-lock');
      body.classList.add('drawer-open');
    });

    function closeDrawer() {
      hamburger.setAttribute('aria-expanded', 'false');
      drawer.classList.remove('mobile-menu-drawer--open');
      drawer.setAttribute('aria-hidden', 'true');
      body.classList.remove('body-lock');
      body.classList.remove('drawer-open');
    }

    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);

    // Main Tabs (Women, Men, Kids)
    const mainTabs = document.querySelectorAll('.mobile-main-tab');
    const mainContents = document.querySelectorAll('.mobile-main-content');
    
    mainTabs.forEach(tab => {
      tab.addEventListener('click', function() {
        mainTabs.forEach(t => t.classList.remove('active'));
        mainContents.forEach(c => c.classList.remove('active'));
        
        this.classList.add('active');
        const targetId = 'maintab-' + this.getAttribute('data-maintab');
        const targetContent = document.getElementById(targetId);
        if (targetContent) targetContent.classList.add('active');
      });
    });

    // Submenu Triggers (Dynamic Links)
    const menuTriggers = document.querySelectorAll('.mobile-menu-trigger');
    menuTriggers.forEach(trig => {
      trig.addEventListener('click', function(e) {
        e.preventDefault();
        const expanded = this.getAttribute('aria-expanded') === 'true';
        this.setAttribute('aria-expanded', !expanded);
        const sub = this.nextElementSibling;
        if (sub) {
          sub.style.display = expanded ? 'none' : 'block';
        }
      });
    });

    // Wishlist bottom bar trigger
    const wishlistTriggers = document.querySelectorAll('.js-mobile-wishlist-trigger');
    wishlistTriggers.forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        if (typeof window.openWishlistDrawer === 'function') {
          window.openWishlistDrawer();
        } else {
          const drawer = document.getElementById('WishlistDrawer');
          if (drawer) {
            drawer.classList.add('is-open');
            document.body.style.overflow = 'hidden';
          }
        }
      });
    });

    // Cart/Bag bottom bar trigger
    const cartTriggers = document.querySelectorAll('.js-mobile-cart-trigger');
    cartTriggers.forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        if (typeof window.openCartDrawer === 'function') {
          window.openCartDrawer();
        } else {
          const drawer = document.getElementById('CartDrawer');
          if (drawer) {
            drawer.classList.add('is-open');
            document.body.style.overflow = 'hidden';
          }
        }
      });
    });

    // Mobile Custom Currency Selector
    const mobileCurrencySelector = document.getElementById('MobileCurrencySelector');
    if (mobileCurrencySelector) {
      const trigger = mobileCurrencySelector.querySelector('#MobileCurrencySelectorTrigger');
      const list = mobileCurrencySelector.querySelector('#MobileCurrencySelectorList');
      const hiddenInput = document.getElementById('MobileCountryCode');
      const form = document.getElementById('MobileLanguageForm');

      if (trigger && list && hiddenInput && form) {
        if (trigger.dataset.listenerInitialized !== 'true') {
          trigger.dataset.listenerInitialized = 'true';
          
          trigger.addEventListener('click', function(e) {
            e.stopPropagation();
            const isOpen = mobileCurrencySelector.classList.toggle('open');
            trigger.setAttribute('aria-expanded', isOpen);
          });

          // Close mobile currency selector on click outside
          document.addEventListener('click', function(e) {
            if (!mobileCurrencySelector.contains(e.target)) {
              mobileCurrencySelector.classList.remove('open');
              trigger.setAttribute('aria-expanded', 'false');
            }
          });

          // Handle click on items
          mobileCurrencySelector.querySelectorAll('.mobile-currency-selector__item').forEach(item => {
            item.addEventListener('click', function() {
              const countryCode = this.getAttribute('data-value');
              hiddenInput.value = countryCode;
              form.submit();
            });
          });
        }
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileMenu);
  } else {
    initMobileMenu();
  }
  document.addEventListener('shopify:section:load', initMobileMenu);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram-reels"] && !Shopify.designMode) return;
  try {
    
  function togglePlay(container) {
    const video = container.querySelector('video');
    if (!video) return;

    if (video.paused) {
      video.play();
      container.classList.add('is-playing');
    } else {
      video.pause();
      container.classList.remove('is-playing');
    }
  }

  function initInstagramReels() {
    document.querySelectorAll('.section-instagram-reels').forEach(function(section) {
      // Play button logic
      section.querySelectorAll('.instagram-reel__media-container').forEach(function(container) {
        const video = container.querySelector('video');
        if (video) {
          if (!video.paused) {
            container.classList.add('is-playing');
          }
          video.addEventListener('play', function() {
            container.classList.add('is-playing');
          });
          video.addEventListener('pause', function() {
            container.classList.remove('is-playing');
          });
        }
      });

      // Pagination logic
      const grid = section.querySelector('.instagram-reels__grid');
      const dots = section.querySelectorAll('.instagram-reels__dot');
      
      if (grid && dots.length > 0) {
        grid.addEventListener('scroll', () => {
          const card = grid.querySelector('.instagram-reel__card');
          if (!card) return;
          const cardWidth = card.offsetWidth + 16; // width + gap
          const activeIndex = Math.round(grid.scrollLeft / cardWidth);
          
          dots.forEach((dot, index) => {
            if (index === activeIndex) {
              dot.classList.add('is-active');
            } else {
              dot.classList.remove('is-active');
            }
          });
        });
      }
    });
  }

  document.addEventListener("DOMContentLoaded", initInstagramReels);
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    initInstagramReels();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["latest-collections"] && !Shopify.designMode) return;
  try {
    
  class LatestCollectionsSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('.latest-collections__grid');
      this.dots = Array.from(this.querySelectorAll('.latest-collections__bar'));
      
      const prevBtn = this.querySelector('.latest-collections__nav-btn--prev');
      const nextBtn = this.querySelector('.latest-collections__nav-btn--next');
      if (prevBtn) prevBtn.addEventListener('click', () => { if (window.innerWidth <= 768) this.prev(); });
      if (nextBtn) nextBtn.addEventListener('click', () => { if (window.innerWidth <= 768) this.next(); });
      
      if (!this.slider) return;
      this.slides = Array.from(this.slider.children);
      if (this.slides.length === 0) return;

      const activeIdxAttr = this.getAttribute('data-active-index');
      this.currentIndex = activeIdxAttr ? parseInt(activeIdxAttr) : 0;
      this.totalSlides = this.slides.length;

      this.init();
    }

    init() {
      // On mobile, if fewer than 5 slides, clone them so wrap-around happens invisibly in deep background without card recycling overlap
      if (this.slides.length > 0 && this.slides.length < 5) {
        const initialCount = this.slides.length;
        for (let i = 0; i < initialCount; i++) {
          const clone = this.slides[i].cloneNode(true);
          clone.classList.add('is-clone');
          this.slider.appendChild(clone);
        }
        this.slides = Array.from(this.slider.children);
        this.totalSlides = this.slides.length;
      }

      // Dot click handling
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          const numDots = this.dots.length;
          if ((this.currentIndex % numDots) !== index) {
            this.currentIndex = index;
            this.update();
          }
        });
      });

      // Card tap handling (side peek cards navigate to center)
      this.slides.forEach((slide, index) => {
        slide.addEventListener('click', (e) => {
          if (window.innerWidth <= 768 && index !== this.currentIndex) {
            e.preventDefault();
            this.currentIndex = index;
            this.update();
          }
        });
      });

      // Touch swipe handling for horizontal coverflow carousel
      let startX = 0;
      let startY = 0;
      let isDragging = false;

      this.slider.addEventListener('touchstart', (e) => {
        if (window.innerWidth > 768) return;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        isDragging = true;
      }, { passive: true });

      this.slider.addEventListener('touchmove', (e) => {
        if (!isDragging || window.innerWidth > 768) return;
        const currentX = e.touches[0].clientX;
        const currentY = e.touches[0].clientY;
        const diffX = startX - currentX;
        const diffY = startY - currentY;

        // Ignore if scrolling vertically up/down the webpage
        if (Math.abs(diffY) > Math.abs(diffX)) return;

        if (Math.abs(diffX) > 35) {
          if (diffX > 0) {
            this.next();
          } else {
            this.prev();
          }
          isDragging = false;
        }
      }, { passive: true });

      this.slider.addEventListener('touchend', () => {
        isDragging = false;
      });

      window.addEventListener('resize', () => {
        this.update();
      });

      this.setAttribute('js-initialized', 'true');
      this.update();
    }

    next() {
      this.currentIndex = (this.currentIndex + 1) % this.totalSlides;
      this.update();
    }

    prev() {
      this.currentIndex = (this.currentIndex - 1 + this.totalSlides) % this.totalSlides;
      this.update();
    }

    update() {
      const isMobile = window.innerWidth <= 768;
      const total = this.totalSlides;

      if (!isMobile) {
        // Reset inline styles on desktop so standard grid takes over and hide clones
        this.slides.forEach((slide) => {
          if (slide.classList.contains('is-clone')) {
            slide.style.display = 'none';
          } else {
            slide.style.display = '';
            slide.style.transform = '';
            slide.style.opacity = '';
            slide.style.zIndex = '';
            slide.style.pointerEvents = '';
            slide.classList.remove('is-active', 'is-peek-left', 'is-peek-right');
          }
        });
        return;
      } else {
        this.slides.forEach((slide) => {
          slide.style.display = '';
        });
      }

      const xStep = 96; // Percentage shift to maintain clean gap and visible side cards

      this.slides.forEach((slide, index) => {
        let diff = index - this.currentIndex;
        let offset = ((diff % total) + total) % total;
        if (offset > Math.floor(total / 2)) {
          offset -= total;
        }

        // Detect if card is wrapping around the back of the carousel (jumping between opposite sides)
        const prevOffset = slide._prevOffset;
        const isWrapping = prevOffset !== undefined && Math.abs(offset - prevOffset) > 1;
        slide._prevOffset = offset;

        if (isWrapping) {
          slide.style.transition = 'none';
        } else {
          slide.style.transition = '';
        }

        let translateX, translateY, scale, opacity, zIndex, pointerEvents;
        let isCenter = false;
        let isLeft = false;
        let isRight = false;

        if (offset === 0) {
          // Active center card
          translateX = '-50%';
          translateY = '-50%';
          scale = 1;
          opacity = 1;
          zIndex = 3;
          pointerEvents = 'auto';
          isCenter = true;
        } else if (offset === -1 || (offset === total - 1 && total > 2)) {
          // Left side peeking card
          translateX = `calc(-50% - ${xStep}%)`;
          translateY = 'calc(-50% + 12px)';
          scale = 0.85;
          opacity = 0.8;
          zIndex = 2;
          pointerEvents = 'auto';
          isLeft = true;
        } else if (offset === 1 || (offset === -(total - 1) && total > 2)) {
          // Right side peeking card
          translateX = `calc(-50% + ${xStep}%)`;
          translateY = 'calc(-50% + 12px)';
          scale = 0.85;
          opacity = 0.8;
          zIndex = 2;
          pointerEvents = 'auto';
          isRight = true;
        } else {
          // Hidden back cards
          translateX = `calc(-50% + ${offset > 0 ? 120 : -120}%)`;
          translateY = 'calc(-50% + 24px)';
          scale = 0.7;
          opacity = 0;
          zIndex = 1;
          pointerEvents = 'none';
        }

        slide.style.transform = `translate3d(${translateX}, ${translateY}, 0) scale(${scale})`;
        slide.style.opacity = opacity;
        slide.style.zIndex = zIndex;
        slide.style.pointerEvents = pointerEvents;

        slide.classList.toggle('is-active', isCenter);
        slide.classList.toggle('is-peek-left', isLeft);
        slide.classList.toggle('is-peek-right', isRight);
      });

      const numDots = this.dots.length;
      this.dots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === (this.currentIndex % numDots));
      });
      
      const currentPageEl = this.querySelector('.latest-collections__current-page');
      if (currentPageEl) {
        const pageNum = (this.currentIndex % numDots) + 1;
        currentPageEl.textContent = pageNum < 10 ? '0' + pageNum : pageNum;
      }
    }
  }

  if (!customElements.get('latest-collections-slider')) {
    customElements.define('latest-collections-slider', LatestCollectionsSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  class CollectionFilters {
    constructor() {
      this.sectionId = 'main-collection-product-grid';
      this.bindEvents();
      this.initSliders();
    }

    bindEvents() {
      this.debouncedSubmit = this.debounce((e, form) => this.onSubmit(e, form), 500);

      document.addEventListener('change', (e) => {
        const form = e.target.closest('#CollectionFiltersForm');
        if (form) {
          if (e.target.type === 'range' || e.target.classList.contains('price-input')) return;
          this.onSubmit(e, form);
        }
      });

      document.addEventListener('submit', (e) => {
        const form = e.target.closest('#CollectionFiltersForm');
        if (form) {
          this.onSubmit(e, form);
        }
      });

      document.addEventListener('click', (e) => {
        if (e.target.closest('#MobileFilterToggle')) {
          this.openFilters();
        }
        if (e.target.closest('#CollectionFiltersClose') || e.target.closest('#CollectionFiltersOverlay')) {
          this.closeFilters();
        }

        const removePriceChip = e.target.closest('.js-remove-price-chip');
        if (removePriceChip) {
          e.preventDefault();
          const currentUrl = new URL(window.location.href);
          currentUrl.searchParams.delete('filter.v.price.gte');
          currentUrl.searchParams.delete('filter.v.price.lte');
          const finalUrl = `${currentUrl.pathname}${currentUrl.search ? currentUrl.search : ''}`;
          this.renderPage(finalUrl);
          return;
        }

        const link = e.target.closest('a');
        if (link && link.closest('.collection-page')) {
          const isFilterLink = link.classList.contains('filter-checkbox') || 
                               link.classList.contains('active-filter-chip') ||
                               link.classList.contains('collection-filters__clear') ||
                               link.classList.contains('collection-filters__reset-btn') ||
                               link.closest('.collection-pagination');
          if (isFilterLink) {
            e.preventDefault();
            this.renderPage(link.href);
          }
        }
      });

      window.addEventListener('popstate', (e) => {
        const url = e.state ? e.state.url : window.location.href;
        this.renderPage(url, false);
      });
    }

    onSubmit(e, form = null) {
      if (e) e.preventDefault();
      form = form || (e.target ? e.target.closest('form') : null);
      if (!form) return;

      const minInput = form.querySelector('input[name*="price.gte"], #PriceFilterMin, #PriceFilterMinStandalone');
      const maxInput = form.querySelector('input[name*="price.lte"], #PriceFilterMax, #PriceFilterMaxStandalone');

      if (minInput && maxInput) {
        let minRaw = minInput.value ? minInput.value.toString().replace(/[^0-9.]/g, '') : '';
        let maxRaw = maxInput.value ? maxInput.value.toString().replace(/[^0-9.]/g, '') : '';
        let minVal = parseFloat(minRaw);
        let maxVal = parseFloat(maxRaw);

        if (!isNaN(minVal) && minVal < 0) minVal = 0;
        if (!isNaN(maxVal) && maxVal < 0) maxVal = 0;

        if (!isNaN(minVal) && !isNaN(maxVal) && minVal > maxVal) {
          const temp = minVal;
          minVal = maxVal;
          maxVal = temp;
        }

        minInput.value = !isNaN(minVal) && minVal > 0 ? minVal : '';
        maxInput.value = !isNaN(maxVal) && maxVal > 0 ? maxVal : '';
      }

      const formData = new FormData(form);
      const searchParams = new URLSearchParams(formData);

      for (const [key, value] of Array.from(searchParams.entries())) {
        if (!value || value.trim() === '') searchParams.delete(key);
      }

      const url = `${window.location.pathname}${searchParams.toString() ? '?' + searchParams.toString() : ''}`;
      this.renderPage(url);
    }

    async renderPage(url, pushState = true) {
      const mainArea = document.querySelector('.collection-page__main');
      if (mainArea) mainArea.style.opacity = '0.5';
      this.closeFilters();

      try {
        const fetchUrl = url.includes('?') ? `${url}&section_id=${this.sectionId}` : `${url}?section_id=${this.sectionId}`;
        const response = await fetch(fetchUrl);
        const html = await response.text();
        
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        const newContainer = doc.querySelector('.collection-page__container');
        const currentContainer = document.querySelector('.collection-page__container');
        
        if (newContainer && currentContainer) {
          currentContainer.innerHTML = newContainer.innerHTML;
          
          if (pushState) {
            window.history.pushState({ url: url }, '', url);
          }
          
          this.initSliders();
          if (window.updateWishlistBadge && typeof wishlist !== 'undefined') {
            document.querySelectorAll('.collection-page__container [data-product-id]').forEach(card => {
              const id = card.getAttribute('data-product-id');
              if (wishlist.includes(id)) {
                const heart = card.querySelector('.best-sellers__wishlist-btn, .new-arrivals__wishlist-btn, .product-single__wishlist-btn, .product-card-ui__wishlist');
                if (heart) heart.classList.add('active');
              }
            });
          }
        }
      } catch (error) {
        console.error('Error fetching collection page:', error);
        window.location.href = url;
      } finally {
        const newMainArea = document.querySelector('.collection-page__main');
        if (newMainArea) newMainArea.style.opacity = '1';
      }
    }

    openFilters() {
      const filterSidebar = document.getElementById('CollectionPageSidebar');
      const filterOverlay = document.getElementById('CollectionFiltersOverlay');
      if (filterSidebar && filterOverlay) {
        filterSidebar.classList.add('open');
        filterOverlay.classList.add('open');
        document.body.classList.add('drawer-open');
        document.body.style.overflow = 'hidden';
      }
    }

    closeFilters() {
      const filterSidebar = document.getElementById('CollectionPageSidebar');
      const filterOverlay = document.getElementById('CollectionFiltersOverlay');
      if (filterSidebar && filterOverlay) {
        filterSidebar.classList.remove('open');
        filterOverlay.classList.remove('open');
        document.body.classList.remove('drawer-open');
        document.body.style.overflow = '';
      }
    }

    initSliders() {
      const minSliders = document.querySelectorAll('.price-slider__range--min');
      const maxSliders = document.querySelectorAll('.price-slider__range--max');

      minSliders.forEach((minSlider, index) => {
        const maxSlider = maxSliders[index];
        if (!maxSlider) return;
        const track = minSlider.parentElement.querySelector('.price-slider__track');
        const minLabel = minSlider.parentElement.nextElementSibling.querySelector('span[id^="label-min"]');
        const maxLabel = minSlider.parentElement.nextElementSibling.querySelector('span[id^="label-max"]');
        const hiddenMin = minSlider.parentElement.parentElement.querySelector('input[name*="gte"]');
        const hiddenMax = minSlider.parentElement.parentElement.querySelector('input[name*="lte"]');

        const updateSlider = () => {
          let minVal = parseInt(minSlider.value);
          let maxVal = parseInt(maxSlider.value);

          if (minVal > maxVal) {
            if (document.activeElement === minSlider) {
              minVal = maxVal;
              minSlider.value = minVal;
            } else {
              maxVal = minVal;
              maxSlider.value = maxVal;
            }
          }

          const parentText = minLabel && minLabel.parentElement ? minLabel.parentElement.textContent : '';
          const activeLocale = parentText.includes('₹') ? 'en-IN' : 'en-US'; 
          if (minLabel) minLabel.textContent = minVal.toLocaleString(activeLocale);
          if (maxLabel) maxLabel.textContent = maxVal.toLocaleString(activeLocale);
          
          const maxTotal = parseInt(minSlider.max) || 1;

          if (hiddenMin) {
            hiddenMin.value = minVal;
            hiddenMin.disabled = (minVal <= 0);
          }
          if (hiddenMax) {
            hiddenMax.value = maxVal;
            hiddenMax.disabled = (maxVal >= maxTotal);
          }

          const percentMin = (minVal / maxTotal) * 100;
          const percentMax = (maxVal / maxTotal) * 100;
          
          if (track) {
            track.style.left = percentMin + "%";
            track.style.width = (percentMax - percentMin) + "%";
          }
        };

        minSlider.addEventListener('input', updateSlider);
        maxSlider.addEventListener('input', updateSlider);
        
        updateSlider();
      });
    }

    debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    new CollectionFilters();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-arrivals"] && !Shopify.designMode) return;
  try {
    
  function initNewArrivals() {
    const section = document.querySelector('.new-arrivals');
    if (!section) return;

    const slider = section.querySelector('.new-arrivals__slider');
    const prevBtns = section.querySelectorAll('.new-arrivals__nav-btn--prev');
    const nextBtns = section.querySelectorAll('.new-arrivals__nav-btn--next');

    if (!slider) return;

    function getScrollAmount() {
      const firstSlide = slider.querySelector('.new-arrivals__slide');
      if (firstSlide) {
        // Scroll by one card width plus the gap
        return firstSlide.offsetWidth + 32;
      }
      return slider.offsetWidth * 0.75;
    }

    prevBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        slider.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
      });
    });

    nextBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        slider.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
      });
    });

    // Desktop mouse drag scrolling
    let isDown = false;
    let startX;
    let scrollLeft;

    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      slider.classList.add('dragging');
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener('mouseleave', () => {
      isDown = false;
      slider.classList.remove('dragging');
    });

    slider.addEventListener('mouseup', () => {
      isDown = false;
      slider.classList.remove('dragging');
    });

    slider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 1.5; // Drag sensitivity
      slider.scrollLeft = scrollLeft - walk;
    });

    // Autoplay card images on hover (Same behavior as best sellers)
    const cards = section.querySelectorAll('.new-arrivals__card');
    cards.forEach(card => {
      const slides = card.querySelectorAll('.new-arrivals__img');
      const dots = card.querySelectorAll('.dot');
      let currentIdx = 0;
      let intervalId = null;

      function showSlide(index) {
        if (slides.length <= 1) return;
        const idx = (index + slides.length) % slides.length;
        currentIdx = idx;

        slides.forEach((slide, i) => {
          if (i === idx) {
            slide.classList.add('active');
          } else {
            slide.classList.remove('active');
          }
        });

        dots.forEach((dot, i) => {
          if (i === idx) {
            dot.classList.add('dot--active');
          } else {
            dot.classList.remove('dot--active');
          }
        });
      }

      dots.forEach(dot => {
        dot.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const slideTo = parseInt(dot.getAttribute('data-slide-to') || 0);
          showSlide(slideTo);
          stopAutoplay();
        });
      });

      function startAutoplay() {
        if (slides.length <= 1) return;
        stopAutoplay();
        intervalId = setInterval(() => {
          showSlide(currentIdx + 1);
        }, 1800);
      }

      function stopAutoplay() {
        if (intervalId) {
          clearInterval(intervalId);
          intervalId = null;
        }
      }

      card.addEventListener('mouseenter', startAutoplay);
      card.addEventListener('mouseleave', () => {
        stopAutoplay();
        showSlide(0);
      });
    });

    // Wishlist heart toggle handled globally in theme-ajax-sync.liquid
  }

  // Load handler
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNewArrivals);
  } else {
    initNewArrivals();
  }

  // Customizer reload support
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.new-arrivals')) {
      initNewArrivals();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.setup();
    }

    setup() {
      const url = this.dataset.url;

      fetch(url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.pr-recommendations-section') || html.querySelector('.pp-recommendations-section');

          if (recommendations && (recommendations.querySelector('.pr-rec-card') || recommendations.querySelector('.pp-related-item-card'))) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (window.DiamondSale && typeof window.DiamondSale.updateProductCardsPriceUI === 'function') {
            window.DiamondSale.updateProductCardsPriceUI();
          }
          
          if (this.classList.contains('pp-recommendations-section')) {
            this.setupProductPageCarousel();
          } else {
            this.setupCarousel();
          }
        })
        .catch(e => {
          console.error(e);
          if (this.classList.contains('pp-recommendations-section')) {
            this.setupProductPageCarousel();
          } else {
            this.setupCarousel();
          }
        });
    }

    setupCarousel() {
      const carousel = this.querySelector('#pr-rec-carousel');
      const prevBtn = this.querySelector('.pr-rec-nav-btn.prev');
      const nextBtn = this.querySelector('.pr-rec-nav-btn.next');
      const dots = this.querySelectorAll('.pr-rec-dot');

      if (!carousel) return;

      const getCardWidth = () => {
        const card = carousel.querySelector('.pr-rec-card');
        return card ? card.offsetWidth + 16 : 220;
      };

      if (prevBtn && nextBtn) {
        nextBtn.addEventListener('click', () => {
          carousel.scrollBy({ left: getCardWidth() * 2, behavior: 'smooth' });
        });
        prevBtn.addEventListener('click', () => {
          carousel.scrollBy({ left: -getCardWidth() * 2, behavior: 'smooth' });
        });
      }

      if (dots.length > 0) {
        dots.forEach((dot, index) => {
          dot.addEventListener('click', () => {
            carousel.scrollTo({
              left: index * getCardWidth(),
              behavior: 'smooth'
            });
          });
        });

        carousel.addEventListener('scroll', () => {
          const scrollPos = carousel.scrollLeft;
          const cardWidth = getCardWidth();
          const activeIndex = Math.min(
            Math.round(scrollPos / cardWidth),
            dots.length - 1
          );

          dots.forEach((dot, idx) => {
            if (idx === activeIndex) {
              dot.classList.add('active');
            } else {
              dot.classList.remove('active');
            }
          });
        }, { passive: true });
      }
    }

    setupProductPageCarousel() {
      const carousel = this.querySelector('#pp-related-grid');
      const prevBtn = this.querySelector('.pp-rel-prev');
      const nextBtn = this.querySelector('.pp-rel-next');
      const dots = this.querySelectorAll('.pp-rel-dot');

      if (!carousel) return;

      const getCardWidth = () => {
        const card = carousel.querySelector('.pp-related-item-card');
        return card ? card.offsetWidth + 10 : 220;
      };

      if (prevBtn && nextBtn) {
        nextBtn.addEventListener('click', () => {
          carousel.scrollBy({ left: getCardWidth() * 2, behavior: 'smooth' });
        });
        prevBtn.addEventListener('click', () => {
          carousel.scrollBy({ left: -getCardWidth() * 2, behavior: 'smooth' });
        });
      }

      if (dots.length > 0) {
        dots.forEach((dot, index) => {
          dot.addEventListener('click', () => {
            carousel.scrollTo({
              left: index * getCardWidth() * (window.innerWidth < 768 ? 2 : 4),
              behavior: 'smooth'
            });
          });
        });

        carousel.addEventListener('scroll', () => {
          const scrollPos = carousel.scrollLeft;
          const cardWidth = getCardWidth();
          const activeIndex = Math.min(
            Math.round(scrollPos / (cardWidth * (window.innerWidth < 768 ? 2 : 4))),
            dots.length - 1
          );

          dots.forEach((dot, idx) => {
            if (idx === activeIndex) {
              dot.classList.add('is-active');
            } else {
              dot.classList.remove('is-active');
            }
          });
        }, { passive: true });
      }

      // Check if carousel overflows and hide/show navigation arrows & dots accordingly
      const checkOverflow = () => {
        const hasOverflow = carousel.scrollWidth > carousel.clientWidth;
        
        if (prevBtn && nextBtn) {
          if (hasOverflow && window.innerWidth >= 768) {
            prevBtn.style.display = 'flex';
            nextBtn.style.display = 'flex';
          } else {
            prevBtn.style.display = 'none';
            nextBtn.style.display = 'none';
          }
        }

        const dotsWrapper = this.querySelector('#pp-rel-dots');
        if (dotsWrapper) {
          dotsWrapper.style.display = hasOverflow ? 'flex' : 'none';
        }
      };

      // Run check on initialization
      setTimeout(checkOverflow, 100);

      // Run check on screen resize
      window.addEventListener('resize', checkOverflow);
    }
  }
  
  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', ProductRecommendations);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
  /* Continuous slow, readable horizontal marquee motion with touch/hover pause and drag support */
  document.addEventListener('DOMContentLoaded', function() {
    var tracks = document.querySelectorAll('.wpr-track');
    tracks.forEach(function(track) {
      // Duplicate child cards once to create a seamless infinite loop without visual jumping
      const children = Array.from(track.children);
      if (children.length > 0) {
        children.forEach(function(child) {
          const clone = child.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          track.appendChild(clone);
        });
      }

      let isDown = false;
      let startX;
      let scrollLeft;
      let isHovered = false;
      let isTouching = false;
      let touchTimeout;

      // Pause continuous motion when user hovers or touches so cards are 100% comfortable to read!
      track.addEventListener('mouseenter', function() { isHovered = true; });
      track.addEventListener('mouseleave', function() { 
        isHovered = false; 
        isDown = false;
        track.style.cursor = 'default';
      });
      track.addEventListener('touchstart', function() { 
        isTouching = true; 
        clearTimeout(touchTimeout);
      }, { passive: true });
      track.addEventListener('touchend', function() { 
        clearTimeout(touchTimeout);
        touchTimeout = setTimeout(function() { isTouching = false; }, 1200); 
      }, { passive: true });

      // Click and drag support
      track.addEventListener('mousedown', function(e) {
        isDown = true;
        track.style.cursor = 'grabbing';
        startX = e.pageX - track.offsetLeft;
        scrollLeft = track.scrollLeft;
      });
      track.addEventListener('mouseup', function() {
        isDown = false;
        track.style.cursor = 'default';
      });
      track.addEventListener('mousemove', function(e) {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - track.offsetLeft;
        const walk = (x - startX) * 1.5;
        track.scrollLeft = scrollLeft - walk;
      });

      // Smooth, slow auto-scroll loop (~25-30px per sec, ultra readable)
      let speed = 0.45;
      function autoScroll() {
        if (!isHovered && !isDown && !isTouching) {
          track.scrollLeft += speed;
          // When we reach halfway (the end of original cards), loop back invisibly!
          if (track.scrollLeft >= track.scrollWidth / 2) {
            track.scrollLeft = track.scrollLeft - (track.scrollWidth / 2);
          }
        }
        requestAnimationFrame(autoScroll);
      }
      requestAnimationFrame(autoScroll);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-highlights"] && !Shopify.designMode) return;
  try {
    
class StoreHighlights {
  constructor(element) {
    this.section = element;
    this.grid = element.querySelector('.store-highlights__grid');
    this.items = Array.from(element.querySelectorAll('.store-highlights__item'));
    this.dots = Array.from(element.querySelectorAll('.store-highlights__dot'));
    if (!this.grid || this.items.length === 0 || this.dots.length === 0) return;
    this.currentIndex = 0;
    this.autoplayTimer = null;
    this.jumpTimeout = null;
    this.isTransitioning = false;
    this.isInfiniteSetup = false;
    this.autoplay = element.getAttribute('data-autoplay') === 'true';
    this.autoplaySpeed = parseInt(element.getAttribute('data-autoplay-speed'), 10) * 1000 || 4000;
    this.init();
  }

  init() {
    if (window.innerWidth <= 991) {
      this.setupInfiniteScroll();
    }

    this.grid.addEventListener('scroll', () => {
      this.handleScroll();
      this.resetAutoplay();
    });

    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        this.scrollToIndex(index);
        this.resetAutoplay();
      });
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth <= 991 && !this.isInfiniteSetup) {
        this.setupInfiniteScroll();
      }
      this.handleScroll();
      this.resetAutoplay();
    });

    this.grid.addEventListener('touchstart', () => this.stopAutoplay(), { passive: true });
    this.grid.addEventListener('mousedown', () => this.stopAutoplay());
    this.grid.addEventListener('touchend', () => this.startAutoplay());
    this.grid.addEventListener('mouseup', () => this.startAutoplay());

    this.handleScroll();
    this.startAutoplay();
  }

  setupInfiniteScroll() {
    if (this.isInfiniteSetup || this.items.length === 0) return;
    this.isInfiniteSetup = true;

    // Clone last item and prepend
    const lastClone = this.items[this.items.length - 1].cloneNode(true);
    lastClone.classList.add('store-highlights__item--clone', 'clone-start');
    lastClone.setAttribute('aria-hidden', 'true');
    this.grid.insertBefore(lastClone, this.items[0]);

    // Clone first item and append
    const firstClone = this.items[0].cloneNode(true);
    firstClone.classList.add('store-highlights__item--clone', 'clone-end');
    firstClone.setAttribute('aria-hidden', 'true');
    this.grid.appendChild(firstClone);

    // Jump to the first real item immediately
    setTimeout(() => {
      this.scrollToIndex(0, false);
    }, 50);
  }

  handleScroll() {
    if (window.innerWidth > 991) return;
    
    const itemWidth = this.items[0].offsetWidth;
    const gap = 16; 
    const itemFullWidth = itemWidth + gap;
    const scrollLeft = this.grid.scrollLeft;
    
    // Calculate current snapped child index
    const currentSnap = Math.round(scrollLeft / itemFullWidth);
    
    // Determine real visual index (subtract 1 for prepended clone)
    let visualIndex = currentSnap - 1;
    if (visualIndex < 0) visualIndex = this.items.length - 1;
    if (visualIndex >= this.items.length) visualIndex = 0;
    
    this.currentIndex = visualIndex;
    this.updateDotsVisually(visualIndex);
    
    if (this.isTransitioning) return;

    // Handle jump for infinite scroll
    clearTimeout(this.jumpTimeout);
    this.jumpTimeout = setTimeout(() => {
      const snapAfterScroll = Math.round(this.grid.scrollLeft / itemFullWidth);
      if (snapAfterScroll === 0) {
        this.scrollToIndex(this.items.length - 1, false);
      } else if (snapAfterScroll === this.items.length + 1) {
        this.scrollToIndex(0, false);
      }
    }, 150);
  }

  updateDotsVisually(index) {
    this.dots.forEach((dot, i) => {
      if (i === index) {
        dot.classList.add('store-highlights__dot--active');
        dot.setAttribute('aria-selected', 'true');
      } else {
        dot.classList.remove('store-highlights__dot--active');
        dot.setAttribute('aria-selected', 'false');
      }
    });
  }

  scrollToIndex(index, smooth = true) {
    if (window.innerWidth > 991) return;
    const itemWidth = this.items[0].offsetWidth;
    const gap = 16;
    // Add 1 to target index to account for the prepended clone
    const targetChildIndex = this.isInfiniteSetup ? index + 1 : index;
    const targetScroll = targetChildIndex * (itemWidth + gap);
    
    if (!smooth) {
      this.isTransitioning = true;
      this.grid.style.scrollBehavior = 'auto';
      this.grid.style.scrollSnapType = 'none';
      this.grid.scrollLeft = targetScroll;
      // Force reflow
      void this.grid.offsetWidth;
      this.grid.style.scrollBehavior = 'smooth';
      this.grid.style.scrollSnapType = 'x mandatory';
      
      setTimeout(() => {
        this.isTransitioning = false;
      }, 50);
    } else {
      this.grid.scrollTo({
        left: targetScroll,
        behavior: 'smooth'
      });
    }
  }

  startAutoplay() {
    if (!this.autoplay || window.innerWidth > 991) return;
    this.stopAutoplay();
    this.autoplayTimer = setInterval(() => {
      const itemWidth = this.items[0].offsetWidth;
      const gap = 16;
      const currentSnap = Math.round(this.grid.scrollLeft / (itemWidth + gap));
      const nextSnap = currentSnap + 1;
      
      this.grid.scrollTo({
        left: nextSnap * (itemWidth + gap),
        behavior: 'smooth'
      });
    }, this.autoplaySpeed);
  }

  stopAutoplay() {
    if (this.autoplayTimer) {
      clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  }

  resetAutoplay() {
    if (window.innerWidth <= 991) {
      this.stopAutoplay();
      this.startAutoplay();
    }
  }
}
document.addEventListener('DOMContentLoaded', () => {
  const initStoreHighlights = () => {
    document.querySelectorAll('.store-highlights').forEach(section => {
      if (!section.dataset.initialized) {
        new StoreHighlights(section);
        section.dataset.initialized = 'true';
      }
    });
  };
  initStoreHighlights();
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.store-highlights');
    if (section) {
      new StoreHighlights(section);
      section.dataset.initialized = 'true';
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const initSliders = () => {
    document.querySelectorAll('.testimonials-v2').forEach(section => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = true;

      const viewport = section.querySelector('[data-slider-viewport]');
      const track = section.querySelector('[data-slider-track]');
      const dots = section.querySelectorAll('.testimonials-v2__nav-dot');
      const cards = section.querySelectorAll('.testimonials-v2__card-wrapper');

      if (!viewport || !dots.length) return;

      const updateDots = () => {
        const viewportLeft = viewport.scrollLeft;
        let closestIndex = 0;
        let minDistance = Infinity;

        cards.forEach((card, index) => {
          const cardLeft = card.offsetLeft;
          const distance = Math.abs(viewportLeft - cardLeft);
          if (distance < minDistance) {
            minDistance = distance;
            closestIndex = index;
          }
        });

        dots.forEach((dot, index) => {
          if (index === closestIndex) {
            dot.classList.add('is-active');
          } else {
            dot.classList.remove('is-active');
          }
        });

        cards.forEach((card, index) => {
          if (index === closestIndex) {
            card.classList.add('is-active');
          } else {
            card.classList.remove('is-active');
          }
        });
      };

      // Listen to scroll events on the viewport
      let scrollTimeout;
      viewport.addEventListener('scroll', () => {
        if (scrollTimeout) {
          window.cancelAnimationFrame(scrollTimeout);
        }
        scrollTimeout = window.requestAnimationFrame(updateDots);
      });

      const getScrollPosition = (card) => {
        return card.offsetLeft - 24; // 24px is 1.5rem for padding
      };

      // Handle dot clicks
      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          const card = cards[index];
          if (card) {
            viewport.scrollTo({
              left: getScrollPosition(card),
              behavior: 'smooth'
            });
          }
        });
      });
      
      // Auto setup initial dot
      updateDots();
      // Autoplay logic
      const autoplay = section.dataset.autoplay === 'true';
      const autoplaySpeed = parseInt(section.dataset.autoplaySpeed, 10) * 1000 || 6000;
      let autoplayInterval;

      const startAutoplay = () => {
        if (!autoplay) return;
        stopAutoplay();
        autoplayInterval = setInterval(() => {
          let activeIndex = Array.from(dots).findIndex(dot => dot.classList.contains('is-active'));
          let nextIndex = (activeIndex + 1) % dots.length;
          
          const card = cards[nextIndex];
          if (card) {
            viewport.scrollTo({
              left: getScrollPosition(card),
              behavior: 'smooth'
            });
          }
        }, autoplaySpeed);
      };

      const stopAutoplay = () => {
        if (autoplayInterval) clearInterval(autoplayInterval);
      };

      const isCenteredLayout = () => {
        return section.querySelector('.testimonials-v2__container--centered') !== null;
      };

      if (autoplay) {
        if (!isCenteredLayout()) {
          // Standard dot autoplay for desktop split layout
          startAutoplay();
          viewport.addEventListener('mouseenter', stopAutoplay);
          viewport.addEventListener('mouseleave', startAutoplay);
          viewport.addEventListener('touchstart', stopAutoplay, {passive: true});
          viewport.addEventListener('touchend', startAutoplay, {passive: true});
        }
      }
    });
  };
  
  initSliders();
  document.addEventListener('shopify:section:load', initSliders);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["three-worlds"] && !Shopify.designMode) return;
  try {
    
  class ThreeWorldsSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('.three-worlds__slider');
      this.slides = Array.from(this.querySelectorAll('.three-worlds__slide'));
      this.dots = Array.from(this.querySelectorAll('.three-worlds__dot'));
      
      if (!this.slider || this.slides.length === 0) return;
      
      this.currentIndex = 0;
      this.totalSlides = this.slides.length;
      
      this.init();
    }
    
    init() {
      this.update();
      
      this.dots.forEach((dot) => {
        dot.addEventListener('click', (e) => {
          this.currentIndex = parseInt(e.target.dataset.index);
          this.update();
        });
      });
      
      this.slides.forEach((slide) => {
        slide.addEventListener('click', (e) => {
          const index = parseInt(slide.dataset.index);
          if (index !== this.currentIndex) {
            this.currentIndex = index;
            this.update();
          }
        });
      });
      
      let startX = 0;
      let isDragging = false;
      
      this.slider.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        isDragging = true;
      }, {passive: true});
      
      this.slider.addEventListener('touchmove', (e) => {
        if (!isDragging) return;
        const currentX = e.touches[0].clientX;
        const diff = startX - currentX;
        
        if (Math.abs(diff) > 50) {
          if (diff > 0) {
            this.next();
          } else {
            this.prev();
          }
          isDragging = false;
        }
      }, {passive: true});
      
      this.slider.addEventListener('touchend', () => {
        isDragging = false;
      });
      
      window.addEventListener('resize', () => {
        this.update();
      });
    }
    
    next() {
      this.currentIndex = (this.currentIndex + 1) % this.totalSlides;
      this.update();
    }
    
    prev() {
      this.currentIndex = (this.currentIndex - 1 + this.totalSlides) % this.totalSlides;
      this.update();
    }
    
    update() {
      const total = this.totalSlides;
      const isMobile = window.innerWidth < 768;
      const xStep = isMobile ? 85 : 95;
      
      this.slides.forEach(slide => {
        let index = parseInt(slide.dataset.index);
        
        let offset = index - this.currentIndex;
        if (offset < -Math.floor(total/2)) offset += total;
        if (offset > Math.floor(total/2)) offset -= total;
        
        let translateX, scale, opacity, zIndex;
        
        if (offset === 0) {
          translateX = 0;
          scale = 1;
          opacity = 1;
          zIndex = 3;
        } else if (offset === 1 || offset === -1) {
          translateX = offset * xStep;
          scale = 0.85;
          opacity = 0.6;
          zIndex = 2;
        } else {
          translateX = offset * (xStep + 15);
          scale = 0.7;
          opacity = 0;
          zIndex = 1;
        }
        
        slide.style.transform = `translateX(${translateX}%) scale(${scale})`;
        slide.style.opacity = opacity;
        slide.style.zIndex = zIndex;
        
        if (this.dots[index]) {
          this.dots[index].classList.toggle('is-active', offset === 0);
        }
      });
    }
  }
  
  if (!customElements.get('three-worlds-slider')) {
    customElements.define('three-worlds-slider', ThreeWorldsSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-call-modal"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const CRM_ENDPOINT = 'https://backend-api.swastikjewel.in/api/auth/lead/shopify-scheduling';

    const modals = document.querySelectorAll('.js-video-call-modal');
    const openBtns = document.querySelectorAll('.js-open-video-call-modal');
    const closeBtns = document.querySelectorAll('.js-close-video-call-modal');

    const openModal = () => {
      // Close hamburger menu drawer if open
      const drawer = document.getElementById('MobileNavDrawer');
      const hamburger = document.querySelector('.header__hamburger');
      if (drawer && drawer.classList.contains('mobile-menu-drawer--open')) {
        if (hamburger) hamburger.setAttribute('aria-expanded', 'false');
        drawer.classList.remove('mobile-menu-drawer--open');
        drawer.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('drawer-open');
      }

      modals.forEach(m => {
        m.style.display = 'flex';
        void m.offsetWidth;
        m.classList.add('is-open');
        const content = m.querySelector('.video-call-modal__content');
        if (content) content.scrollTop = 0;
      });
      document.body.style.overflow = 'hidden';
      document.body.classList.add('body-lock');
    };

    const closeModal = () => {
      modals.forEach(m => {
        m.classList.remove('is-open');
        setTimeout(() => {
          if (!m.classList.contains('is-open')) {
            m.style.display = 'none';
          }
        }, 300);
      });
      document.body.style.overflow = '';
      document.body.classList.remove('body-lock');
      document.documentElement.style.overflow = '';
    };

    // Expose globally
    window.openVideoCallModal = openModal;
    window.closeVideoCallModal = closeModal;

    openBtns.forEach(btn => btn.addEventListener('click', (e) => { e.preventDefault(); openModal(); }));
    closeBtns.forEach(btn => btn.addEventListener('click', closeModal));

    // Close on Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' || e.keyCode === 27) {
        closeModal();
      }
    });

    // ---- Date picker: generate next 7 days ----
    const dateContainer = document.querySelector('.js-date-options');
    if (dateContainer) {
      const today = new Date();
      const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      let html = '';
      for (let i = 0; i < 7; i++) {
        const d = new Date(today);
        d.setDate(today.getDate() + i);
        const dayName = i === 0 ? 'Today' : (i === 1 ? 'Tmrw' : days[d.getDay()]);
        const dateStr = d.getDate() + ' ' + months[d.getMonth()];
        const value = d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
        html += '<button type="button" class="video-call-form__pill js-date-pill" data-value="' + value + '">' +
                '<span class="day">' + dayName + '</span><span class="date">' + dateStr + '</span></button>';
      }
      dateContainer.innerHTML = html;
    }

    // ---- Pill selection (date + time) tracked via .is-active ----
    const activatePills = (selector) => {
      const pills = document.querySelectorAll(selector);
      pills.forEach(pill => pill.addEventListener('click', () => {
        pills.forEach(p => p.classList.remove('is-active'));
        pill.classList.add('is-active');
      }));
    };
    setTimeout(() => { activatePills('.js-date-pill'); activatePills('.js-time-pill'); }, 50);

    // ---- Timing (Now vs Later) shows/hides the date & time picker ----
    const datetimeWrapper = document.querySelector('.js-datetime-wrapper');
    const timingRadios = document.querySelectorAll('input[name="timing"]');
    const updateTiming = () => {
      const sel = document.querySelector('input[name="timing"]:checked');
      if (sel && datetimeWrapper) {
        datetimeWrapper.style.display = sel.value === 'Later' ? 'block' : 'none';
      }
    };
    timingRadios.forEach(r => r.addEventListener('change', updateTiming));
    updateTiming();
    
    // ---- Platform (Google Meet vs WhatsApp) shows/hides the email field ----
    const emailGroup = document.querySelector('.js-email-group');
    const platformRadios = document.querySelectorAll('input[name="platform"]');
    const updatePlatform = () => {
      const sel = document.querySelector('input[name="platform"]:checked');
      if (sel && emailGroup) {
        if (sel.value === 'WhatsApp Video Call') {
          emailGroup.style.display = 'none';
        } else {
          emailGroup.style.display = 'flex';
        }
      }
    };
    platformRadios.forEach(r => r.addEventListener('change', updatePlatform));
    updatePlatform();

    // ---- Submit -> POST JSON to the CRM ----
    const form = document.querySelector('.video-call-form');
    const fieldsWrap = document.querySelector('.video-call-form__fields');
    const successBox = document.querySelector('.video-call-form__success');
    const errorBox = document.querySelector('.video-call-form__errors');

    const pad = (n) => String(n).padStart(2, '0');

    // "02:00 PM" -> "14:00"
    const to24Hour = (str) => {
      const m = (str || '').trim().match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
      if (!m) return str;
      let h = parseInt(m[1], 10);
      const ap = m[3].toUpperCase();
      if (ap === 'PM' && h !== 12) h += 12;
      if (ap === 'AM' && h === 12) h = 0;
      return pad(h) + ':' + m[2];
    };

    const showError = (msg) => {
      if (!errorBox) return;
      errorBox.textContent = msg;
      errorBox.style.display = 'block';
    };
    const clearError = () => {
      if (errorBox) { errorBox.textContent = ''; errorBox.style.display = 'none'; }
    };

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        clearError();

        const platformEl = document.querySelector('input[name="platform"]:checked');
        const timingEl = document.querySelector('input[name="timing"]:checked');
        const firstName = (document.getElementById('VideoCallFirstName').value || '').trim();
        const lastName = (document.getElementById('VideoCallLastName').value || '').trim();
        const email = (document.getElementById('VideoCallEmail').value || '').trim();
        const whatsapp = (document.getElementById('VideoCallWhatsApp').value || '').trim();

        // Validation
        if (!firstName || !lastName) { showError('Please enter your first and last name.'); return; }
        
        if (platformEl && platformEl.value === 'Google Meet') {
          if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { showError('Please enter a valid email address for Google Meet.'); return; }
        }
        
        if (!whatsapp) { showError('Please enter your WhatsApp number.'); return; }

        // Meeting date & time
        let meetingDate, meetingTime;
        if (timingEl && timingEl.value === 'Later') {
          const dPill = document.querySelector('.js-date-options .js-date-pill.is-active');
          const tPill = document.querySelector('.js-time-options .js-time-pill.is-active');
          if (!dPill) { showError('Please choose a date.'); return; }
          if (!tPill) { showError('Please choose a time.'); return; }
          meetingDate = dPill.getAttribute('data-value');
          meetingTime = to24Hour(tPill.getAttribute('data-value'));
        } else {
          // "As soon as possible" -> today's date and the current time.
          const now = new Date();
          meetingDate = now.getFullYear() + '-' + pad(now.getMonth() + 1) + '-' + pad(now.getDate());
          meetingTime = pad(now.getHours()) + ':' + pad(now.getMinutes());
        }

        const payload = {
          first_name: firstName,
          last_name: lastName,
          email: email,
          whatsapp_number: whatsapp,
          meeting_date: meetingDate,
          meeting_time: meetingTime,
          meeting_platform: platformEl ? platformEl.value : 'Google Meet',
          recaptcha_token: 'test_token_no_recaptcha_yet'
        };

        const submitBtn = form.querySelector('.video-call-form__submit');
        const originalText = submitBtn ? submitBtn.textContent : '';
        if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Scheduling...'; }

        fetch(CRM_ENDPOINT, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        })
        .then((res) => {
          return res.text().then((text) => {
            if (!res.ok) {
              let serverMsg = text;
              try { const j = JSON.parse(text); serverMsg = j.message || j.error || j.detail || text; } catch (e) {}
              const httpErr = new Error('HTTP ' + res.status + (serverMsg ? ': ' + serverMsg : ''));
              httpErr.isHttp = true;
              throw httpErr;
            }
            return text;
          });
        })
        .then(() => {
          if (fieldsWrap) fieldsWrap.classList.add('hidden');
          if (successBox) successBox.style.display = 'flex';
        })
        .catch((err) => {
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = originalText; }
          if (err && err.name === 'TypeError') {
            showError('We could not reach the scheduling service (network/CORS). Please try again, or reach us on WhatsApp.');
          } else if (err && err.isHttp) {
            showError('We could not schedule your call: ' + err.message.replace(/^HTTP \d+:\s*/, '') + '. Please try again, or reach us on WhatsApp.');
          } else {
            showError('Sorry, we could not schedule your call right now. Please try again, or reach us on WhatsApp.');
          }
          console.error('[Video call scheduling] FAILED\n  Endpoint:', CRM_ENDPOINT, '\n  Error:', err, '\n  Payload sent:', payload);
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["whatsapp-widget"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const toggleBtns = document.querySelectorAll('.js-whatsapp-toggle');
    const closeBtns = document.querySelectorAll('.js-whatsapp-close');
    const menu = document.querySelector('.js-whatsapp-menu');
    const overlay = document.querySelector('.whatsapp-widget__overlay');
    const videoCallTriggers = document.querySelectorAll('.js-video-call-trigger');

    function closeWhatsappMenu() {
      if (menu) menu.classList.remove('is-active');
      if (overlay) overlay.classList.remove('is-active');
      document.body.classList.remove('whatsapp-menu-open');
    }

    if (toggleBtns.length > 0 && menu) {
      toggleBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          const isActive = menu.classList.toggle('is-active');
          if (overlay) overlay.classList.toggle('is-active', isActive);
          document.body.classList.toggle('whatsapp-menu-open', isActive);
        });
      });

      if (closeBtns.length > 0) {
        closeBtns.forEach(btn => {
          btn.addEventListener('click', closeWhatsappMenu);
        });
      }

      // Close when clicking outside
      document.addEventListener('click', (e) => {
        if (!e.target.closest('.js-whatsapp-widget') && !e.target.closest('.js-whatsapp-toggle')) {
          closeWhatsappMenu();
        }
      });
    }

    // Handle "Shop via Video Call" option
    videoCallTriggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault(); // Stop navigation if modal exists on this page
        closeWhatsappMenu();
        if (typeof window.openVideoCallModal === 'function') {
          window.openVideoCallModal();
        } else {
          const videoCallModals = document.querySelectorAll('.js-video-call-modal');
          if (videoCallModals.length > 0) {
            videoCallModals.forEach(modal => {
              modal.style.display = 'flex';
              modal.classList.add('is-open');
            });
            document.body.style.overflow = 'hidden';
            document.body.classList.add('body-lock');
          }
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
